module.exports = __webpack_public_path__ + "img/what-we-do-icon-5.5daa8490.svg";